module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-1920x2-44902c733c4a1f0fda00cf1fd059e34a.jpg";